<template>
  <div class="w-100 p-r f-row-c overfh" :style="{height:numH}" @click.stop="onPlay">
    <img src='../static/img/video_icon.png' class="video_icon" v-if='!playTip'/>
    <!-- this.$imgUrl+file "../static/img/dome.mp4"-->
    <video :src='fileUrl' class="videobox" :controls='playTip' ref='myFile'></video>
  </div>
</template>

<script>
export default {
  name: 'videoBox',
  props: ['file','numH'],
  data() {
    return {
      playTip: false,
      fileUrl:''
    };
  },
  watch:{ 
    fileUrl:function(newVal){ 
       this.fileUrl=this.file=newVal
    }
  },
  mounted() {
    this.fileUrl=this.file
  },

  methods: {
    onClose(){
      this.$refs.myFile.pause()
    },
    onPlay() {
      this.playTip = !this.playTip
      console.log('playTip',this.playTip)
      if (this.playTip) {
        this.$refs.myFile.play()
      } else {
        this.$refs.myFile.pause()
      }
    }
  },
};
</script>

<style scoped>
.p-r{
    position: relative;
    overflow: hidden;
    background: #333333;
}
.video_icon{ 
    position: absolute;
    width: 12%;
    z-index: 2;
}
.videobox{
  /* height: 100%; */
  width: 100%;
}
</style>